
import { Record, Union } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { list_type, record_type, bool_type, anonRecord_type, int32_type, float64_type, class_type, option_type, string_type, union_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { StorageId_$reflection, ReservationState_$reflection } from "./Shared.js";
import { CustomProperty_$reflection } from "./PropertyConfiguration.js";

export class ReservationToolType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Tool", "ToolWithQuantity", "Consumable", "Set", "Group"];
    }
}

export function ReservationToolType_$reflection() {
    return union_type("Shared.Planning.ReservationToolType", [], ReservationToolType, () => [[], [], [], [], []]);
}

export class ReservationDto extends Record {
    constructor(Id, GroupId, State, Name, Description, StartDate, EndDate, ToolInformation, ReceiverInformation, SenderInformation) {
        super();
        this.Id = Id;
        this.GroupId = GroupId;
        this.State = State;
        this.Name = Name;
        this.Description = Description;
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.ToolInformation = ToolInformation;
        this.ReceiverInformation = ReceiverInformation;
        this.SenderInformation = SenderInformation;
    }
}

export function ReservationDto_$reflection() {
    return record_type("Shared.Planning.ReservationDto", [], ReservationDto, () => [["Id", string_type], ["GroupId", option_type(string_type)], ["State", ReservationState_$reflection()], ["Name", string_type], ["Description", string_type], ["StartDate", class_type("System.DateTime")], ["EndDate", class_type("System.DateTime")], ["ToolInformation", anonRecord_type(["Id", string_type], ["Name", string_type], ["Quantity", option_type(string_type)], ["RawFloatQuantity", option_type(float64_type)], ["RawIntQuantity", option_type(int32_type)], ["StorageId", string_type], ["Type", ReservationToolType_$reflection()], ["Unit", string_type])], ["ReceiverInformation", anonRecord_type(["CurrentReceiverId", option_type(string_type)], ["IsDeleted", bool_type], ["ReceiverId", string_type], ["ReceiverName", string_type])], ["SenderInformation", anonRecord_type(["ReceiverId", string_type], ["SenderName", string_type])]]);
}

export class ReservationDetailDto extends Record {
    constructor(Id, GroupId, Name, Description, StartDate, EndDate, State, BusinessUnitId, ToolsInformation, ToolsWithQuantityInformation, SetsInformation, ConsumablesInformation, ReceiverInformation, SenderInformation) {
        super();
        this.Id = Id;
        this.GroupId = GroupId;
        this.Name = Name;
        this.Description = Description;
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.State = State;
        this.BusinessUnitId = BusinessUnitId;
        this.ToolsInformation = ToolsInformation;
        this.ToolsWithQuantityInformation = ToolsWithQuantityInformation;
        this.SetsInformation = SetsInformation;
        this.ConsumablesInformation = ConsumablesInformation;
        this.ReceiverInformation = ReceiverInformation;
        this.SenderInformation = SenderInformation;
    }
}

export function ReservationDetailDto_$reflection() {
    return record_type("Shared.Planning.ReservationDetailDto", [], ReservationDetailDto, () => [["Id", string_type], ["GroupId", option_type(string_type)], ["Name", string_type], ["Description", string_type], ["StartDate", class_type("System.DateTime")], ["EndDate", class_type("System.DateTime")], ["State", ReservationState_$reflection()], ["BusinessUnitId", option_type(string_type)], ["ToolsInformation", list_type(anonRecord_type(["CurrentLocation", string_type], ["CustomProperties", list_type(CustomProperty_$reflection())], ["DisplayName", string_type], ["Id", string_type], ["ImageUrl", string_type], ["InventoryNumber", string_type], ["Location", string_type], ["Manufacturer", string_type], ["Model", string_type], ["QRCodeIds", string_type], ["SerialNumber", string_type], ["Storage", string_type], ["StorageSpace", string_type]))], ["ToolsWithQuantityInformation", list_type(anonRecord_type(["CurrentLocation", string_type], ["CustomProperties", list_type(CustomProperty_$reflection())], ["DisplayName", string_type], ["Id", string_type], ["ImageUrl", string_type], ["InventoryNumber", string_type], ["Location", string_type], ["Manufacturer", string_type], ["Model", string_type], ["QRCodeIds", string_type], ["Quantity", string_type], ["RawQuantity", int32_type], ["SerialNumber", string_type], ["Storage", string_type], ["StorageId", StorageId_$reflection()], ["StorageSpace", string_type], ["Unit", string_type]))], ["SetsInformation", list_type(anonRecord_type(["CurrentLocation", string_type], ["CustomProperties", list_type(CustomProperty_$reflection())], ["DisplayName", string_type], ["Id", string_type], ["ImageUrl", string_type], ["InventoryNumber", string_type], ["Location", string_type], ["Manufacturer", string_type], ["Model", string_type], ["QRCodeIds", string_type], ["SerialNumber", string_type], ["Storage", string_type], ["StorageSpace", string_type]))], ["ConsumablesInformation", list_type(anonRecord_type(["CustomProperties", list_type(CustomProperty_$reflection())], ["Id", string_type], ["ImageUrl", string_type], ["InventoryNumber", string_type], ["Name", string_type], ["QRCodeIds", string_type], ["Quantity", string_type], ["RawQuantity", float64_type], ["Storage", string_type], ["StorageId", StorageId_$reflection()], ["StorageSpace", string_type], ["Unit", string_type]))], ["ReceiverInformation", anonRecord_type(["CurrentReceiverId", option_type(string_type)], ["IsDeleted", bool_type], ["ReceiverId", string_type], ["ReceiverName", string_type])], ["SenderInformation", anonRecord_type(["ReceiverId", string_type], ["SenderName", string_type])]]);
}

export class ReservationAssignDto extends Record {
    constructor(ReceiverId, IsStateCompleted, Comment$, PlannedReturnDate) {
        super();
        this.ReceiverId = ReceiverId;
        this.IsStateCompleted = IsStateCompleted;
        this.Comment = Comment$;
        this.PlannedReturnDate = PlannedReturnDate;
    }
}

export function ReservationAssignDto_$reflection() {
    return record_type("Shared.Planning.ReservationAssignDto", [], ReservationAssignDto, () => [["ReceiverId", string_type], ["IsStateCompleted", bool_type], ["Comment", string_type], ["PlannedReturnDate", option_type(string_type)]]);
}

export function Helper_stateToTranslationKey(_arg) {
    if (_arg.tag === 0) {
        return "general.planned";
    }
    else {
        return "general.completed";
    }
}

